import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Only add auth headers to EVready API calls
  // console.log('AuthInterceptor - req.url: ', req.url);
  if (req.url.startsWith(environment.apiUrl)) {
    return from(authService.getAuthToken()).pipe(
      switchMap(token => {
        const headers: Record<string, string> = {};

        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        } else {
          console.error('No token available, no auth header will be set');
          // No token available (e.g., refresh token expired) → treat as unauthenticated
          // authService.clearAuthState();
          // const returnUrl = router.url;
          // router.navigate(['/login'], { queryParams: { returnUrl } });
        }

        const authReq = req.clone({ setHeaders: headers });
        return next(authReq);
      })
    );
  }

  return next(req);
};
